import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconBeachSand = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconBeachSand",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: [_jsx("path", {
    d: "M5.8 10.36c0 .25.2.47.47.47h4.2a1.5 1.5 0 0 1 2.84 0h4.21c.26 0 .47-.22.47-.47v-1.3a.47.47 0 0 0-.47-.46H6.27a.47.47 0 0 0-.47.47zM17 7.66a2.2 2.2 0 0 0-2.56-2.01.5.5 0 0 1-.5-.28 2.2 2.2 0 0 0-4.08 0c-.09.2-.3.32-.51.28l-.36-.03a2.2 2.2 0 0 0-2.2 2.04zm-.46 8.44.67-4.34h-3.9c-.15.44-.5.8-.93.94a3.76 3.76 0 0 0 3.73 3.4zl-.14.95h-.29a4.7 4.7 0 0 1-4.67-4.34 1.5 1.5 0 0 1-.96-.95h-3.9l1.2 7.84c.04.23.23.4.46.4h7.3c.24 0 .43-.17.47-.4l.39-2.55h1.33a.47.47 0 0 0 0-.94z"
  }), _jsx("path", {
    d: "M11.9 11.85a.55.55 0 1 0 0-1.11.55.55 0 0 0 0 1.1"
  })]
}));